import { render, staticRenderFns } from "./DecisionStyle.vue?vue&type=template&id=45c8e8f7"
import script from "./DecisionStyle.vue?vue&type=script&lang=js"
export * from "./DecisionStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports